import { render } from "./ClusterSelector.vue?vue&type=template&id=38bad83e"
import script from "./ClusterSelector.vue?vue&type=script&lang=js"
export * from "./ClusterSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__